import Vue from 'vue'

declare global {
  interface Window {
    MonacoEnvironment?: {
      getWorkerUrl: (moduleId: string, label: string) => string;
    };
  }
}

if (process.client) {
  window.MonacoEnvironment = {
    getWorkerUrl: function (_moduleId, label) {
      if (label === 'json') return '/_nuxt/json.worker.js';
      if (label === 'css') return '/_nuxt/css.worker.js';
      if (label === 'html') return '/_nuxt/html.worker.js';
      if (label === 'typescript' || label === 'javascript') return '/_nuxt/ts.worker.js';
      if (label === 'python') return '/_nuxt/python.worker.js';
      return '/_nuxt/editor.worker.js';
    },
  };
}